export const LOADING_DETAILS = 'LOADING_DETAILS'
export const FETCH_PROJECT = "FETCH_PROJECT"
export const FETCH_PROJECT_FAIL = "FETCH_PROJECT_FAIL"
export const PATCH_PROJECT = "PATCH_PROJECT"
export const PATCH_PROJECT_FAIL = "PATCH_PROJECT_FAIL"
export const DELETE_PROJECT_FAIL = "DELETE_PROJECT_FAIL"
export const DELETE_PROJECT = "DELETE_PROJECT"
export const CLEAR_PROJECT = "CLEAR_PROJECT"
export const POST_PROJECT = "POST_PROJECT"
export const POST_PROJECT_FAIL = "POST_PROJECT_FAIL"
export const SET_FAIL_MESSAGE_PROJECT = "SET_FAIL_MESSAGE_PROJECT"
